export default {"src":"/_next/static/media/instagram.edc98129.svg","height":12,"width":12};